
import { Component, Vue } from "vue-property-decorator"
import { State, Getter } from "vuex-class"

import ZendeskHelp from "@/components/ZendeskHelp.vue"

import { BaseState } from "@/store"
import { CurrentUser } from "@/types/user"

	@Component({
		components: {
			"zendesk-help": ZendeskHelp
		}
	})
export default class SideBar extends Vue {
		@State((state: BaseState) => state.me) private readonly me!: CurrentUser;

		@Getter("getRecordName") private readonly recordName!: string;
		@Getter("getHasIntegrations") private readonly hasIntegrations!: boolean;
}
